import { Box, Stack, Tooltip, Typography, TypographyOwnProps } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colours } from "../../shared/colors";

const CreateQuoteSectionTitle = ({ title, tooltip, variant }: { title: string; tooltip?: string, variant?: TypographyOwnProps["variant"] }) => (
	<Stack direction="row" alignItems="center">
		<Box pr="0.5em">
			<Typography variant={variant ?? "subtitle1"}>{title}</Typography>
		</Box>
		{tooltip && (
			<Tooltip title={tooltip} placement="right">
				<InfoOutlinedIcon sx={{ fontSize: "1em", color: colours.primaryDark.main }} />
			</Tooltip>
		)}
	</Stack>
);

export default CreateQuoteSectionTitle;
